import React, { useState } from 'react';
import ChatWindow from './ChatWindow';
import QuizWindow from './QuizWindow';
import './Widget.css';

const Widget = () => {
  const [mode, setMode] = useState(null);               // 'faq' or 'quiz'
  const [loading, setLoading] = useState(false);
  const [faqMessages, setFaqMessages] = useState([]);

  const resetMode = () => setMode(null);

  const renderHeader = () => {
    if (!mode) return null;
    const title = mode === 'faq' ? 'Ask About School' : 'Student Quiz Assessment';
    return (
      <div className="widget__header">
        <button className="widget__back" onClick={resetMode}>&lt;</button>
        <h2 className="widget__title">{title}</h2>
      </div>
    );
  };

  return (
    <div className="widget">
      {renderHeader()}

      {!mode && (
        <div className="widget__mode-buttons">
          <button className="widget__mode-button" onClick={() => setMode('faq')}>
            Ask About School
          </button>
          <button className="widget__mode-button" onClick={() => setMode('quiz')}>
            Student Quiz Assessment
          </button>
        </div>
      )}

      <div className="widget__chat-area">
      {loading && (
        <div className="widget__message widget__message--bot">
            <span className="widget__typing-indicator">...</span>
        </div>
        )}

        {mode === 'faq' && (
          <ChatWindow
            messages={faqMessages}
            setMessages={setFaqMessages}
            setLoading={setLoading}
          />
        )}
        {mode === 'quiz' && <QuizWindow />}
      </div>
    </div>
  );
};

export default Widget;
